import React from 'react';
import { AddressType } from '../CommonTypes';
import Selectable from '../Selectable';
import Address from './Address';
import './SelectableAddress.scss';

type SelectableAddressProps = {
    id: string;
    address: AddressType;
    selected: boolean;
    onClicked: (selected: boolean) => void;
    onEditSelectedAddress: () => void;
    style?: React.CSSProperties;
    index: number;
};

const SelectableAddress = ({
    id,
    address,
    selected,
    onClicked,
    onEditSelectedAddress,
    style,
    index
}: SelectableAddressProps): JSX.Element => {
    return (
        <div className='selectableAddress--wrapper'>
            <Selectable
                id={`select${id}`}
                onClicked={(selected) => {
                    onClicked(selected);
                }}
                selected={selected}
                style={style}>
                <Address
                    id={id}
                    address={address}
                    onEditAddressClick={onEditSelectedAddress}
                    showEditButton={index === 0 ? false : true}
                />
            </Selectable>
        </div>
    );
};

export default SelectableAddress;
